import { CheckCircle2, XCircle } from "lucide-react";

export default function GroupRunProgress({ run, t }) {
  const pct = run.total ? ((run.progress || 0) / run.total) * 100 : 0;
  return (
    <div className="tech-card p-4" data-testid="group-run">
      <div className="flex items-center justify-between mb-2">
        <div className="label-tech text-slate-400">{t("groupEmail.runTitle")}</div>
        <div className="font-mono-data text-xs text-slate-400" data-testid="group-run-counts">
          {run.progress || 0}/{run.total} · <span className="text-emerald-300">{run.sent || 0} ok</span>
          {!!run.failed && <span className="text-rose-300"> · {run.failed} ko</span>}
        </div>
      </div>
      <div className="h-1.5 bg-slate-800 rounded-full overflow-hidden mb-3">
        <div className="h-full bg-amber-500 transition-[width] duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="space-y-1 max-h-40 overflow-y-auto">
        {(run.results || []).map((r) => (
          <div key={r.user_id} className="flex items-center gap-2 text-[11px] font-mono-data" data-testid={`group-result-${r.user_id}`}>
            {r.sent ? <CheckCircle2 size={12} className="text-emerald-400 shrink-0" /> : <XCircle size={12} className="text-rose-400 shrink-0" />}
            <span className="text-slate-300 truncate">{r.email}</span>
            <span className="text-slate-500">{r.lang.toUpperCase()}</span>
            {r.error && <span className="ml-auto text-rose-300 truncate max-w-[50%]">{r.error}</span>}
          </div>
        ))}
      </div>
      {run.status === "completed" && (
        <div className="text-xs text-emerald-300 mt-3" data-testid="group-run-done">{t("groupEmail.runDone", { sent: run.sent || 0, failed: run.failed || 0 })}</div>
      )}
    </div>
  );
}
